import * as v2 from '@/core/services/api/v2';

export const playerService = {
  // `findOrCreatePlayer`, `checkPlayerExists` e `rechargeStamina` sairam (05/09/2026):
  // rotas do Strapi sem chamador. O jogador nasce com a conta e a energia e
  // derivada no servidor.

  // `claimDailyReward` saiu daqui: a store de player fala com o V2 direto
  // (`v2.resgatarDiaria`) e ninguém mais chamava esta versão do Strapi.

  /**
   * Recuperação de senha, agora de verdade: o V2 envia o link pelo Resend.
   * A resposta é 204 exista a conta ou não — a tela diz "se houver conta,
   * enviamos", nunca "conta não encontrada".
   */
  async forgotPassword(email) {
    await v2.esqueciSenha(email);
  },

  /** O código vem do link do e-mail (`?code=`); vale 30 minutos e um uso. */
  async resetPassword(code, password) {
    await v2.redefinirSenha(code, password);
  }
};
